"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var transition = function transition(_ref) {
  var duration = _ref.duration,
      easing = _ref.easing;
  return ["border-color ".concat(duration.shorter, "ms ").concat(easing.easeInOut), "background-color ".concat(duration.shorter, "ms ").concat(easing.easeInOut), "color ".concat(duration.shorter, "ms ").concat(easing.easeInOut), "opacity ".concat(duration.shorter, "ms ").concat(easing.easeInOut), "width ".concat(duration.shorter, "ms ").concat(easing.easeInOut)];
};

var _default = transition;
exports.default = _default;